export default function StatusBadge({ status }) {
  const cfg = {
    ativa:    { label: 'ATIVO',    cls: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-400', dot: 'bg-emerald-400 animate-pulse' },
    pausada:  { label: 'PAUSADO',  cls: 'bg-surface-2/60 border-white/[0.08] text-ink-3',             dot: 'bg-surface-5' },
    rascunho: { label: 'RASCUNHO', cls: 'bg-amber-500/10 border-amber-500/30 text-amber-400',       dot: 'bg-amber-400' },
  }[status] || { label: status, cls: 'bg-surface-2 border-white/[0.08] text-ink-3', dot: 'bg-surface-5' };

  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full ${cfg.cls} border text-[10px] font-semibold tracking-wide`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}
